export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sport.vue?vue&type=template&id=4146f1ca"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/sport/sport.vue?vue&type=template&id=4146f1ca
// module id = t8UU
// module chunks = 0